import React, { useState, useEffect, useRef, Fragment } from "react";
import { connect, useDispatch } from "react-redux";
import CustomText from "pages/_components/CustomText/CustomText";
import MainContainer from "pages/_components/MainContainer";
import Head from "pages/_components/Head";
import { goBack } from "connected-react-router";
import { Col, Row } from "react-bootstrap";
import Button from "pages/_components/Button";
import { arrayOf, bool, shape, string } from "prop-types";
import Image from "pages/_components/Image";
import * as i18nUtils from "util/i18n";
import AppleAppBtn from "styles/images/app-store-badge.png";
import GooglePlayBtn from "styles/images/google-play-badge.png";
import CustomData from "pages/_components/CustomData/CustomData";
import InfoModal from "pages/_components/InfoModal";
import TextField from "pages/_components/fields/TextField";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import * as configUtils from "util/config";
import { selectors as modalselectors, actions as modalActions } from "reducers/modal";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as actionSoftToken, selectors as selectorSoftToken } from "reducers/softToken";
import { selectors as settingsSelectors, actions as settingsActions } from "reducers/settings";
import Container from "pages/_components/Container";
import GridTable from "pages/_components/GridTable/GridTable";
import { ResponsiveHeader } from "pages/_components/header";
import SlideDesvincularToken from "./_components/SlideDesvincularToken";
import SlideVincularToken from "./_components/SlideVincularToken";

const FORM_ID = "onboarding.step.verifySMS";

const MyToken = ({ isMobile, displayModal, verifyCode, devices, device, isFetching, mobilePhone, deviceStatus }) => {
    const dispatch = useDispatch();
    const [slideVisibleVincular, setslideVisibleVincular] = useState(false);
    const [dispositivoVinculado, setdispositivoVinculado] = useState(false);
    const [isValidating, setIsValidating] = useState(false);
    const [resendAvailable, setResendAvailable] = useState(true);
    const [validateError, setvalidateError] = useState(false);
    const [visibleQueryToken, setvisibleQueryToken] = useState(false);
    const [token, settoken] = useState(false);
    const [deviceDelete, setdeviceDelete] = useState({ shortLabel: "", idDevice: "" });
    const [slideVisible, setslideVisible] = useState(false);
    const [formRef2, setFormRef2] = useState();
    const [formRef, setFormRef] = useState();
    const timerRef = useRef(null);
    const credentialType = "password";
    const TIME_TO_SEND_OTHER_CODE = configUtils.get("validation_code.retry.duration", 3) * 60000;

    useEffect(() => {
        dispatch(actionSoftToken.getDevicesByUser());
        dispatch(actionSoftToken.registerDevicePre());
        dispatch(settingsActions.getUserData());
    }, []);
    useEffect(() => {
        if (devices && devices.length > 0) {
            if (window.cordova) {
                const dispositivos = devices.find((x) => JSON.parse(x.extraInfo).idDevice === device.uuid);
                if (dispositivos) {
                    setvisibleQueryToken(true);
                    settoken(true);
                } else {
                    setvisibleQueryToken(false);
                    settoken(false);
                }
            } else {
                setvisibleQueryToken(true);
            }
        }
    }, [devices, device, isFetching, deviceStatus]);
    useEffect(() => {
        if (isValidating && verifyCode?.data && verifyCode?.status !== "OK" && verifyCode?.status !== "") {
            setvalidateError(true);
        } else if (isValidating && verifyCode?.status === "OK") {
            setIsValidating(false);
            if (verifyCode?.type === "send") {
                dispatch(modalActions.modalShow());
            } else if (verifyCode?.type === "receive") {
                setdispositivoVinculado(true);
                dispatch(modalActions.modalClose());
            }
        }
    }, [isValidating, verifyCode]);

    useEffect(() => {
        if (deviceStatus && deviceStatus === "INVALID_CREDENTIAL") {
            if (token) {
                setvisibleQueryToken(true);
                setslideVisible(true);
                setslideVisibleVincular(false);
                setdispositivoVinculado(false);
            } else {
                setslideVisibleVincular(true);
                setdispositivoVinculado(true);
                setvisibleQueryToken(false);
                setslideVisible(false);
            }
            if (visibleQueryToken) {
                formRef2.setErrors({
                    password: i18nUtils.get(
                        credentialType === "password"
                            ? "preferences.password.password.incorrect"
                            : "login.step1.secondFactor.invalid",
                    ),
                });
            } else {
                formRef.setErrors({
                    password: i18nUtils.get(
                        credentialType === "password"
                            ? "preferences.password.password.incorrect"
                            : "login.step1.secondFactor.invalid",
                    ),
                });
            }
        }
    }, [isFetching, deviceStatus]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const sendCode = (mobilePhoneToSend, shouldDisableBtn) => {
        setIsValidating(true);
        dispatch(onboardingActions.verifyCodeSend("sms", "", mobilePhoneToSend || mobilePhone, true));
        if (shouldDisableBtn) {
            setResendAvailable(false);
            clearTimeout(timerRef.current);
            timerRef.current = setTimeout(() => {
                setResendAvailable(true);
            }, TIME_TO_SEND_OTHER_CODE);
        }
    };

    const formikValidateProps = {
        validateOnChange: true,
        validateOnBlur: false,
        initialValues: {
            code: "",
            code1: "",
            code2: "",
            code3: "",
            code4: "",
            code5: "",
        },
        validationSchema: () =>
            Yup.object().shape({
                code: Yup.string().required(i18nUtils.get("onboarding.step.verifySMS.code.error.empty", "")),
                code1: Yup.string().required(i18nUtils.get("onboarding.step.verifySMS.code.error.empty", "")),
                code2: Yup.string().required(i18nUtils.get("onboarding.step.verifySMS.code.error.empty", "")),
                code3: Yup.string().required(i18nUtils.get("onboarding.step.verifySMS.code.error.empty", "")),
                code4: Yup.string().required(i18nUtils.get("onboarding.step.verifySMS.code.error.empty", "")),
                code5: Yup.string().required(i18nUtils.get("onboarding.step.verifySMS.code.error.empty", "")),
            }),
        onSubmit: (_event, data) => {
            const { code, code1, code2, code3, code4, code5 } = data;
            const codeSend = `${code}${code1}${code2}${code3}${code4}${code5}`;
            setIsValidating(true);
            dispatch(onboardingActions.verifyCodeReceive(codeSend, "sms", "", mobilePhone, "", false, true));
            dispatch(modalActions.modalClose());
        },
    };

    const handleStopTimer = (e) => {
        // chequea que el click no sea desde el input o que no sea desde los botones
        if (e.target.localName !== "input" && e.target.parentElement.id === "") {
            clearTimeout(timerRef.current);
            dispatch(modalActions.modalClose());
        }
    };

    const handleSendCode = (e) => {
        sendCode(mobilePhone, true);
        e.stopPropagation();
    };

    const handleOnSubmit = (formikPropsParam, event, data) => {
        event.stopPropagation();
        formikPropsParam.onSubmit(event, data);
    };

    const onFocus = (id, value) => {
        if (value === "") {
            return;
        }
        if (document.getElementById(id)) {
            document.getElementById(id).focus();
        }
    };

    const confirmationToken = () => {
        if (devices.length > 0) {
            setslideVisibleVincular(true);
        } else {
            dispatch(actionSoftToken.registerUserDevice({ shortLabel: "Redmi-Note1211", uuid: "SM-558887448965" }));
        }
    };

    const reemplazarDispositivo = (password) => {
        dispatch(actionSoftToken.registerUserDeviceReplace(password));
        setslideVisibleVincular(false);
        setdispositivoVinculado(false);
    };
    const QueryToken = () => {
        const eliminarDispotivo = (password) => {
            const { shortLabel, idDevice } = deviceDelete;
            dispatch(
                actionSoftToken.deleteUserDevice({
                    shortLabel,
                    idDevice,
                    _password: password,
                }),
            );
            setslideVisible(false);
            setvisibleQueryToken(false);
            setslideVisibleVincular(false);
            setdispositivoVinculado(false);
        };
        return (
            <Fragment>
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText text={i18nUtils.get("preferences.myToken.devicelink")} />
                    </h1>
                </Col>
                <div className="ilustracion text-center mb-10">
                    <Image src="figma/illustrations/onboarding16.svg" className="svg-image logo" />
                </div>
                <CustomText text="Dispositivo vinculado" className="font-size-lg font-weight-500" />
                {devices.map((item) => (
                <Row 
                    className="box success py-6 px-6 items-center">
                    <Col xs={4}>
                        <CustomText
                            text={`${JSON.parse(item.extraInfo)?.manufacturer ?? ""}-${JSON.parse(
                                item.extraInfo,
                            )?.model ?? ""}`}
                        />
                    </Col>
                    <Col xs={8} className="flex justify-end">
                        <Button
                            className={isMobile ? "btn-icon-only btn-inline pr-0" : "btn-icon-only btn-inline"}
                            image="images/delete-message.svg"
                            bsStyle={isMobile ? "text" : "outline"}
                            label="settings.softToken.device.remove"
                            defaultLabelText="Desvincular"
                            loading={false}
                            onClick={() => {
                                setslideVisible(true);
                                setdeviceDelete({
                                    shortLabel: JSON.parse(item.extraInfo)?.shortLabel ?? "",
                                    idDevice: item.idDevice,
                                });
                            }}
                        />
                    </Col>
                    
                </Row>
                ))}

                <SlideDesvincularToken
                    slideIsVisible={slideVisible}
                    closeSlide={() => setslideVisible(false)}
                    setFormRef2={setFormRef2}
                    deviceDelete={deviceDelete}
                    eliminarDispotivo={eliminarDispotivo}
                />
            </Fragment>
        );
    };
    const onFocusDown = (id, code, idLast, setFieldValue, value) => {
        if (code === "Backspace" && value === "") {
            if (document.getElementById(id)) {
                document.getElementById(id).focus();
            }
            if (idLast) {
                setFieldValue(idLast, "");
            }
        }
    };
    const createValidateEmailBodyModal = () => (
        <div>
            <Formik {...formikValidateProps}>
                {(allFormik) => (
                    <Form noValidate>
                        <GridTable className="token-code-fields">
                            <GridTable.Container>
                                <GridTable.Data>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code"
                                        id="code"
                                        hideLabel
                                        onKeyUp={(e) => {
                                            onFocus("code1", e.target.value);
                                        }}
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code1"
                                        id="code1"
                                        onKeyUp={(e) => {
                                            onFocus("code2", e.target.value);
                                        }}
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code", e.code || e.key, null, null, allFormik.values.code1);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        onKeyUp={(e) => {
                                            onFocus("code3", e.target.value);
                                        }}
                                        name="code2"
                                        id="code2"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code1", e.code || e.key, null, null, allFormik.values.code2);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        onKeyUp={(e) => {
                                            onFocus("code4", e.target.value);
                                        }}
                                        name="code3"
                                        id="code3"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code2", e.code || e.key, null, null, allFormik.values.code3);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code4"
                                        id="code4"
                                        onKeyUp={(e) => {
                                            onFocus("code5", e.target.value);
                                        }}
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown("code3", e.code || e.key, null, null, allFormik.values.code4);
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                                <GridTable.Data sm={1}>
                                    <Field
                                        autoComplete="off"
                                        component={TextField}
                                        idForm={FORM_ID}
                                        maxLength={1}
                                        name="code5"
                                        id="code5"
                                        hideLabel
                                        autoFocus={!isMobile}
                                        spaceEnabled={false}
                                        placeholder=""
                                        onKeyDown={(e) => {
                                            onFocusDown(
                                                "code4",
                                                e.code || e.key,
                                                "code5",
                                                allFormik.setFieldValue,
                                                allFormik.values.code5,
                                            );
                                        }}
                                        variant="outlined"
                                    />
                                </GridTable.Data>
                            </GridTable.Container>
                        </GridTable>
                        <Button
                            bsStyle="link"
                            // label="onboarding.step.verifyEmail.modal.resendcode.action"
                            defaultLabelText="No me llegó el SMS"
                            loading={false}
                            onClick={handleSendCode}
                            disabled={!resendAvailable}
                            id="save-mobilePhone-button"
                            className="btn-lg"
                        />

                        <Button
                            bsStyle="primary"
                            label="onboarding.step.verifySMS.modal.button.validate"
                            loading={false}
                            onClick={(ev) => handleOnSubmit(formikValidateProps, ev, allFormik.values)}
                            block
                            disabled={
                                !(
                                    allFormik.isValid &&
                                    allFormik.dirty &&
                                    allFormik.values.code?.length === 1 &&
                                    allFormik.values.code1?.length === 1 &&
                                    allFormik.values.code2?.length === 1 &&
                                    allFormik.values.code3?.length === 1 &&
                                    allFormik.values.code4?.length === 1 &&
                                    allFormik.values.code5?.length === 1
                                )
                            }
                            id="submit-button"
                        />
                    </Form>
                )}
            </Formik>
        </div>
    );

    if (validateError) {
        return (
            <>
                <Head titleText={isMobile ? "Activación de Token" : "Gestión de Token"} onBack={onHeaderBack} />
                <MainContainer>
                    {!isMobile && (
                        <Container>
                            <Col xs={12} md={8} mdOffset={2}>
                                <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />
                            </Col>
                        </Container>
                    )}

                    <div>
                        <Col xs={12} md={8} mdOffset={2}>
                            <h1 className="text-center">
                                <CustomText
                                    text={i18nUtils.get("onboarding.sms.errorSms", "No pudimos validar tu SMS")}
                                />
                            </h1>
                        </Col>
                        <div className="illustration text-center">
                            <Image src="figma/illustrations/onboarding14.svg" className="svg-image logo" />
                        </div>
                        <br />
                        <Col xs={12} md={8} mdOffset={2} className="box box-border-soft" style={{ padding: "20px" }}>
                            <CustomText
                                text={i18nUtils.get(
                                    "onboarding.sms.errorSms.description",
                                    "Se produjo un error al validar el SMS. Por favor, intente nuevamente.",
                                )}
                            />
                        </Col>

                        <Button
                            className="mt-8"
                            bsStyle="primary"
                            label="global.accept"
                            loading={false}
                            onClick={() => {
                                setvalidateError(false);
                            }}
                        />
                    </div>
                </MainContainer>
            </>
        );
    }

    const MobileView = () => (
        <div className="app-default-container">
            <div className="app-default-header no-bg">
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText
                            text={i18nUtils.get("preferences.myToken.linkDevice", "Vinculá tu dispositivo")}
                        />
                    </h1>
                </Col>
            </div>
            <div className="app-default-content">
                <div className="ilustracion text-center">
                    <Image src="figma/illustrations/onboarding16.svg" className="svg-image logo" />
                </div>
                <br />
                <Col xs={12} md={8} mdOffset={2}>
                    <CustomText
                        className="font-size-lg"
                        text={i18nUtils.get(
                            "preferences.myToken.activeTokenSecurity",
                            "Activá el Token como segundo factor de autenticación para autorizar tus transacciones realizadas a través del Online Banking.",
                        )}
                    />
                </Col>
                <div className="container--alert" role="alert">
                    <div className="alert alert-info">
                        <CustomData
                            icon="information_fill.svg"
                            titleText="Te estaremos enviando un código de validación vía SMS."
                            keepSpaceIfNoValue={false}
                        />
                    </div>
                </div>
            </div>
            <footer className="app-default-footer">
                <Button
                    className="mb-10"
                    bsStyle="primary"
                    label="settings.options.myToken.vincular"
                    defaultLabelText="Vincular"
                    loading={false}
                    onClick={() => {
                        sendCode(mobilePhone, false);
                    }}
                />
            </footer>
        </div>
    );

    const MobileViewSuccess = () => (
        <div className="app-default-container">
            <div className="app-default-header no-bg">
                <Col xs={12} md={8} mdOffset={2}>
                    <h1 className="text-center">
                        <CustomText
                            text={i18nUtils.get("preferences.myToken.linkDevice", "Confirmá tu dispositivo")}
                        />
                    </h1>
                </Col>
            </div>
            <div className="app-default-content">
                <div className="ilustracion text-center mb-10">
                    <Image src="figma/illustrations/onboarding3.svg" className="svg-image logo" />
                </div>
                <CustomText
                    className="font-size-lg"
                    text={i18nUtils.get(
                        "preferences.myToken.confirmValidationDevice",
                        "Asegurate que el modelo del dispositivo que deseas vincular sea correcto.",
                    )}
                />
                <Row 
                    className="box success py-6 px-6 mt-8">
                    <Col xs={4}>
                        <CustomText
                            text={i18nUtils.get("preferences.myToken.device", "Dispositivo ")} 
                        />
                    </Col>
                    <Col xs={8} className="text-right">
                        <CustomText 
                            className="font-size-lg font-weight-700" 
                            text={i18nUtils.get("", `${device?.manufacturer ?? ""}-${device?.model ?? ""}`)}
                        />
                    </Col>
                </Row>
            </div>
            <div className="app-default-footer">
                <Button
                    className="mb-10"
                    bsStyle="primary"
                    label="global.confirm"
                    defaultLabelText="Confirmar"
                    loading={false}
                    onClick={confirmationToken}
                />
            </div>
        </div>
    );

    const desktopView = () => (
        <div style={{ textAlign: "center" }} className={!isMobile && "box box-shadow py-12 px-11"}>
            <h1>
                <CustomText text="Vinculá el token desde tu dispositivo" />
            </h1>
            <div className="ilustracion text-center">
                <Image src="figma/illustrations/onboarding3.svg" className="svg-image logo" />
            </div>
            <CustomText
                text={i18nUtils.get(
                    "",
                    "Activá el Token como segundo factor de autenticación para autorizar tus transacciones realizadas a través del Online Banking.",
                )}
            />
            <br />
            <br />
            <b>
                <CustomText text={i18nUtils.get("", "Descargá la App de BiBank desde:")} />
            </b>
            <div className="download-apk-buttons justify-items-center">
                {/* Google Play */}
                <img
                    src={GooglePlayBtn}
                    alt="Descargar desde la play store de google"
                    className="GooglePlayBtn justify-self-end"
                />
                {/* App Store */}
                <img src={AppleAppBtn} alt="Descargar desde la app store" className="AppleAppBtn justify-self-start" />
            </div>
        </div>
    );
    const viewValidation = () => {
        if (visibleQueryToken) {
            return QueryToken();
        }
        if (isMobile) {
            if (dispositivoVinculado) {
                return MobileViewSuccess();
            }
            return MobileView();
        }
        return desktopView();
    };
    return (
        <>
            <ResponsiveHeader defaultTitle="Gestión de Token" onClickBack={onHeaderBack} />
            <MainContainer showLoader={isFetching}>
                {viewValidation()}
            </MainContainer>

            {displayModal && (
                <InfoModal
                    noAcceptButton
                    noCancelButton
                    bodyInfoText="texto"
                    modalSubtitle={`Ingresá el código de validación enviado por sms al ${mobilePhone}`}
                    useScroll
                    body={createValidateEmailBodyModal}
                    onClick={handleStopTimer}
                />
            )}
            <SlideVincularToken
                devices={devices}
                reemplazarDispositivo={reemplazarDispositivo}
                slideIsVisible={slideVisibleVincular}
                setFormRef={setFormRef}
                closeSlide={() => setslideVisibleVincular(false)}
            />
        </>
    );
};

MyToken.propTypes = {
    isMobile: bool.isRequired,
    displayModal: bool,
    verifyCode: shape({}),
    devices: arrayOf([]).isRequired,
    device: shape({}).isRequired,
    isFetching: bool,
    mobilePhone: string,
    deviceStatus: string,
};

MyToken.defaultProps = {
    displayModal: false,
    verifyCode: {},
    isFetching: false,
    mobilePhone: "",
    deviceStatus: false,
};

const mapStateToProps = (state) => ({
    displayModal: modalselectors.getDisplayModal(state),
    verifyCode: onboardingSelectors.getVerifyCode(state),
    devices: selectorSoftToken.getDevicesByUser(state),
    device: selectorSoftToken.registerDevicePre(state),
    isFetching: selectorSoftToken.getFetching(state),
    mobilePhone: settingsSelectors.getMobilePhone(state) || "",
    deviceStatus: selectorSoftToken.getDeviceStatus(state),
});

export default connect(mapStateToProps)(MyToken);
